import { ConfigProvider } from "antd";
import { libertifyThemeV2, LtiSessionExpired } from "@libertify/ui";
import mainBg from "@/assets/images/main-background.png";

export const LtiSessionExpiredPage = () => (
  <ConfigProvider theme={libertifyThemeV2}>
    <LtiSessionExpired backgroundImage={mainBg} />
  </ConfigProvider>
);

export default LtiSessionExpiredPage;
